import { render } from "./CalendarToday.vue?vue&type=template&id=312b51b7&scoped=true"
import script from "./CalendarToday.vue?vue&type=script&lang=js"
export * from "./CalendarToday.vue?vue&type=script&lang=js"

import "./CalendarToday.vue?vue&type=style&index=0&id=312b51b7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312b51b7"]])

export default __exports__